document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.lna-product');
  if (!root) return;

  // Accordeons
  root.querySelectorAll('.lna-accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      trigger.closest('.lna-accordion').classList.toggle('is-open');
    });
  });

  // Variantes : les radios remplissent le select natif utilisé par le form Shopify
  var variantSelect = document.getElementById('lna-variant-select');
  var priceEl = document.getElementById('lna-price');
  var optionInputs = root.querySelectorAll('.lna-option input[type="radio"]');

  function getSelectedOptions() {
    var groups = {};
    optionInputs.forEach(function (input) {
      if (input.checked) groups[input.name] = input.value;
    });
    return Object.values(groups);
  }

  // Nécessite l'objet product en JSON pour matcher les variantes.
  // Simplifié ici : si un seul variant correspond à la combinaison de titres, on le sélectionne.
  optionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var selected = getSelectedOptions().join(' / ');
      var options = variantSelect.querySelectorAll('option');
      options.forEach(function (opt) {
        if (opt.textContent.trim() === selected || opt.textContent.trim().indexOf(selected) !== -1) {
          variantSelect.value = opt.value;
        }
      });
    });
  });

  // Sélecteur de quantité
  var qtyInput = document.getElementById('lna-qty-input');
  var qtyMinus = document.getElementById('lna-qty-minus');
  var qtyPlus = document.getElementById('lna-qty-plus');
  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  // Ajout au panier en AJAX (évite le rechargement de page)
  var form = document.getElementById('lna-product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('lna-add-to-cart');
      var originalText = btn.textContent;
      btn.textContent = 'Ajout en cours...';
      btn.disabled = true;

      var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantSelect.value, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Ajouté !';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1500);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  }
});